//用户
export const usersUrl = '/identity/users'
export const getUserPage = () => `${usersUrl}`
export const getUser = (id) => `${usersUrl}/${id}`
const shareUsersUrl = '/app/user'
export const createUser = () => `${shareUsersUrl}`
export const updateUser = (id) => `${shareUsersUrl}/${id}`
export const deleteUser = (id) => `${shareUsersUrl}/${id}`
export const getUserDictionary = (version) => `${shareUsersUrl}/user-dictionary?version=${version}`
//用户角色
export const getUserRole = (id) => `${usersUrl}/${id}/roles`
export const lockUser = () => `/app/account/lock`
// 获取授权
export const configuration = () => `app/account/current-user-configuration`
